/**
 * The cost-estimate screen's own route path (frame 132:555). It absorbed the
 * retired `/c/$campaignId/burn-rate`: this screen's per-account table and
 * seven-day actual are what survives of that page, everything else of it
 * (the night window, the acquisition sheet) does not.
 *
 * Relative to the router's `basepath`, like every other route literal in
 * this plane.
 */

import { interpolatePath } from '@tanstack/react-router';

export const ESTIMATE_PATH = '/c/$campaignId/estimate';

export function estimatePath(campaignId: string): string {
  return interpolatePath({ path: ESTIMATE_PATH, params: { campaignId } }).interpolatedPath;
}
